import groq from 'groq'

export const feeProductVariantFragment = groq`
  variantID,
  title,
  price,
  comparePrice,
`
